import { useChainAwareNavigate } from 'hooks/useChainAwareNavigate'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { PresetRange } from 'state/mint/v3/actions'
import styled from 'styled-components'
import { deleteURLParam } from 'utils/routes'

const Container = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.cardSecondary};
  height: 44px;
`

const PresetButton = styled.button<{ $isActive: boolean }>`
  flex: 1;
  border: none;
  background: ${({ theme, $isActive }) => ($isActive ? theme.accentActive : 'transparent')};
  color: ${({ theme, $isActive }) => ($isActive ? theme.cardPrimary : theme.deprecated_text1)};
  font-size: 13px;
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 500)};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    background: ${({ theme, $isActive }) => ($isActive ? theme.accentAction : theme.cardPrimary)};
  }

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0%;
    bottom: 0%;
    width: 1px;
    background: ${({ theme }) => theme.cardBorderPrimary};
    opacity: ${({ $isActive }) => ($isActive ? 0 : 1)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

interface PresetsButtonsProps {
  selectedPreset: PresetRange
  onPresetSelect: (preset: PresetRange) => void
  disabled?: boolean
}

const PRESETS = [
  { key: PresetRange.NARROW, label: 'Narrow' },
  { key: PresetRange.COMMON, label: 'Medium' },
  { key: PresetRange.WIDE, label: 'Wide' },
  { key: PresetRange.FULL, label: 'Full Range' },
]

export default function PresetsButtons({ selectedPreset, onPresetSelect, disabled = false }: PresetsButtonsProps) {
  const { search } = useLocation()
  const navigate = useChainAwareNavigate()

  function handlePresetSelect(preset: PresetRange) {
    if (disabled) return

    let updatedSearch = deleteURLParam(search, 'minPrice')
    updatedSearch = deleteURLParam(updatedSearch, 'maxPrice')
    navigate({ search: `?${updatedSearch}` }, { replace: true })

    onPresetSelect(preset)
  }

  return (
    <Container>
      {PRESETS.map(({ key, label }) => (
        <PresetButton
          key={key}
          $isActive={selectedPreset === key}
          disabled={disabled}
          onClick={() => handlePresetSelect(key)}
        >
          {label}
        </PresetButton>
      ))}
    </Container>
  )
}
